"use client";
import Link from "next/link";
import { ShieldCheck, UsersRound, Phone, ArrowUp } from "lucide-react";
import { FiMessageCircle } from "react-icons/fi";
import { useFooter } from "@/hooks/customer/useHeader";
import FooterMobile from "../mobile/FooterMobile";
import Image from "next/image";

const Footer = () => {
  const { scrollToTop, footerRef, showBackToTop } = useFooter();

  return (
    <>
      <FooterMobile />
      <footer
        ref={footerRef}
        className="bg-primary text-white ta-desktop-home-footer hidden lg:block"
      >
        <div className="">
          {showBackToTop && (
            <button
              type="button"
              onClick={scrollToTop}
              aria-label="Back to top"
              className="hidden lg:flex fixed bottom-6 right-6 z-50 items-center justify-center w-12 h-12 rounded-full bg-primary text-white shadow-lg shadow-black/20 border border-white/10 transition-all duration-200 ease-out hover:bg-secondary hover:text-primary hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-secondary/60 focus:ring-offset-2 focus:ring-offset-primary cursor-pointer"
            >
              <ArrowUp size={18} />
            </button>
          )}

          {/* Desktop / Tablet layout */}
          <div className="grid grid-cols-12 gap-2 gap-y-10 ta-desktop-home-container py-8">
            <div className="col-span-2">
              <div className="font-bold text-base! mb-7">Company</div>
              <ul className="space-y-3 text-white link-text capitalize">
                <li>
                  <Link href="/about-us" onClick={scrollToTop} prefetch={false}>
                    About us
                  </Link>
                </li>
                <li>
                  <Link href="/sitemap" onClick={scrollToTop} prefetch={false}>
                    Sitemaps
                  </Link>
                </li>
                <li>
                  <Link href="/contact-us" onClick={scrollToTop} prefetch={false}>
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2">
              <div className="font-bold text-base! mb-7">Support</div>
              <ul className="space-y-3 text-white link-text capitalize">
                <li>
                  <Link href="/support" onClick={scrollToTop} prefetch={false}>
                    Help Center
                  </Link>
                </li>
                <li>
                  <Link href="/contact-us" onClick={scrollToTop} prefetch={false}>
                    Feedback
                  </Link>
                </li>
                <li>
                  <Link href="/faq" onClick={scrollToTop} prefetch={false}>
                    FAQs
                  </Link>
                </li>
                <li>
                  <Link href="/privacy-policy" onClick={scrollToTop} prefetch={false}>
                    Privacy Policy
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-3">
              <div className="font-bold text-base! mb-7">Partner With Us</div>
              <ul className="space-y-3 text-white link-text capitalize">
                <li>
                  <Link href="/become-supplier" onClick={scrollToTop} prefetch={false}>
                    Become a Partner
                  </Link>
                </li>
                <li>
                  <Link href="/collaborate" onClick={scrollToTop} prefetch={false}>
                    Collaboration with us
                  </Link>
                </li>
                <li>
                  <Link href="/write-for-us" onClick={scrollToTop} prefetch={false}>
                    Write for us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="col-span-2">
              <div className="font-bold text-base! mb-7">Explore</div>
              <ul className="space-y-3 text-white link-text capitalize">
                <li>
                  <Link href="/blog" onClick={scrollToTop} prefetch={false}>
                    TripsAdora Blogs
                  </Link>
                </li>
                <li>
                  <Link href="/trip-cash" onClick={scrollToTop} prefetch={false}>
                    Trip Cash+
                  </Link>
                </li>
                <li>
                  <Link href="/refer-earn" onClick={scrollToTop} prefetch={false}>
                    Refer and Earn
                  </Link>
                </li>
                <li>
                  <Link href="/write-review" onClick={scrollToTop} prefetch={false}>
                    write a review
                  </Link>
                </li>
              </ul>
            </div>

            {/* Stay Connected */}
            <div className="col-span-3">
              <div className="space-y-5 w-full">
                <div>
                  <div className="font-bold text-base! mb-3">Follow Us</div>
                  <div className="grid grid-cols-5 gap-2 max-w-56">
                    <Link
                      href="https://web.facebook.com/profile.php?id=61586602331134"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src="/images/fb-logo.png"
                        alt="Facebook"
                        width={24}
                        height={24}
                        className="w-6 h-6"
                      />
                    </Link>
                    <Link
                      href="https://x.com/tripsadora"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src="/images/x-logo.png"
                        alt="X"
                        width={24}
                        height={24}
                        className="w-6 h-6"
                      />
                    </Link>
                    <Link
                      href="https://jp.pinterest.com/tripsadora/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src="/images/pinterest-logo.png"
                        alt="Pinterest"
                        width={24}
                        height={24}
                        className="w-6 h-6"
                      />
                    </Link>
                    <Link
                      href="https://www.instagram.com/tripsadora/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Image
                        src="/images/instagram-logo.png"
                        alt="Instagram"
                        width={24}
                        height={24}
                        className="w-6 h-6"
                      />
                    </Link>
                  </div>
                </div>

                <div className="flex items-center justify-between gap-3 bg-white px-4 py-1 rounded-lg">
                  <Image
                    src="/images/pay1.png"
                    alt="Pay"
                    width={24}
                    height={24}
                    className="w-6 h-auto object-contain"
                  />
                  <Image
                    src="/images/pay2.png"
                    alt="Pay"
                    width={28}
                    height={24}
                    className="w-7 h-auto object-contain"
                  />
                  <Image
                    src="/images/pay3.png"
                    alt="Pay"
                    width={24}
                    height={24}
                    className="w-6 h-auto object-contain"
                  />
                  <Image
                    src="/images/pay4.png"
                    alt="Pay"
                    width={20}
                    height={24}
                    className="w-5 h-auto object-contain"
                  />
                  <Image
                    src="/images/pay5.png"
                    alt="Pay"
                    width={24}
                    height={24}
                    className="w-6 h-auto object-contain"
                  />
                  <Image
                    src="/images/pay6.png"
                    alt="Pay"
                    width={24}
                    height={24}
                    className="w-6 h-auto object-contain"
                  />
                  <Image
                    src="/images/pay7.png"
                    alt="Pay"
                    width={24}
                    height={24}
                    className="w-6 h-auto object-contain"
                  />
                </div>
              </div>
            </div>
          </div>

          <hr />

          <div className="py-3 flex flex-wrap items-center justify-between text-white text-sm ta-desktop-home-container">
            <div>© 2026 TripsAdora. All rights reserved.</div>
            <div className="flex flex-wrap gap-6 items-center">
              <div className="flex items-center gap-2">
                <ShieldCheck size={16} />{" "}
                <span className="span-text text-white font-normal">
                  Secure Booking
                </span>
              </div>
              <div className="flex items-center gap-2">
                <UsersRound size={16} />{" "}
                <span className="span-text text-white font-normal">
                  10M+ Travels
                </span>
              </div>
              <div className="flex items-center gap-2">
                <Phone size={16} />{" "}
                <span className="span-text text-white font-normal">
                  +817092256870
                </span>
              </div>
              <div className="flex items-center gap-2">
                <FiMessageCircle size={16} />{" "}
                <span className="span-text text-white font-normal">
                  24/7 Support
                </span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
